<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <div>
    <div v-if="!loading">
      <ik-data-table
        ref="dataTable"
        :filter="realFilter"
        :model="model"
        entity-name="SalesStatistics"
        only-display="1"
      >
        <template #primaryButton>
          <v-btn
            color="amber lighten-4 black--text"
            elevation="0"
            @click="download"
          >
            <v-icon left>
              mdi-export
            </v-icon>
            {{ $t('export') }}
          </v-btn>
        </template>
        <template #footer="{tableItems}">
          <v-card
            :class="!$vuetify.breakpoint.lgAndUp ? 'px-4' : 'px-6'"
            class="py-2 mr-4 text-body-2"
            color="grey lighten-3 black--text"
            elevation="0"
          >
            {{ $t('totalCount') }}: {{ totalCount(tableItems) }}
          </v-card>
          <v-card
            :class="!$vuetify.breakpoint.lgAndUp ? 'px-4' : 'px-6'"
            class="py-2 mr-4 text-body-2"
            color="grey lighten-3 black--text"
            elevation="0"
          >
            {{ $t('TotalAmount') }}: {{ totalPrice(tableItems) | priceDisplay }}
          </v-card>
        </template>
      </ik-data-table>
      <a ref="downloadfile" />
    </div>
    <div
      v-else
      class="d-flex align-center justify-center"
      style="height: 65vh"
    >
      <v-progress-circular
        indeterminate
        size="64"
      />
    </div>
  </div>
</template>

<script>
import DishStatistics from '@/model/dataLayer/api/statistic/DishStatistics'
import IkDataTable from '@/plugins/EntityFrameWork/IkDataTable.vue'
import { sumBy } from 'lodash'
import { exportDishStatisticCsv } from '@/model/dataLayer/service/newExport'

export default {
  components: {
    IkDataTable
  },
  data: function () {
    return {
      loading: false,

      model: DishStatistics,
      dishSalesList: []
    }
  },
  computed: {
    realFilter () {
      return {
        dateFilter: this.$parent.dateRange
      }
    }
  },
  watch: {
    '$parent.dateRange': {
      handler: function (val) {
        this.reload()
      },
      deep: true,
      immediate: true
    }
  },
  async mounted () {
    await this.reload()
  },
  methods: {
    totalPrice (items) {
      return sumBy(items, x => {
        if (!x.totalPrice) {
          return parseFloat(x.totalCount) * x.price
        } else {
          return parseFloat(x.totalPrice)
        }
      })
    },
    totalCount (items) {
      return sumBy(items, (x) => {
        return parseFloat(x.totalCount)
      })
    },
    async download () {
      const ids = this.$refs.dataTable.filterItem?.categoryId?.join() ?? ''
      const data = await exportDishStatisticCsv(...this.$parent.dateRange, ids)
      const content = new Blob([data], { type: 'text/csv' })
      const urlObj = window.URL
      const url = urlObj.createObjectURL(content)
      this.$refs.downloadfile.href = url
      this.$refs.downloadfile.acceptCharset = 'UTF-8'
      this.$refs.downloadfile.click()
      urlObj.revokeObjectURL(url)
    },
    async reload () {
      this.loading = true
      const dateFilter = [...this.$parent.dateRange]
      this.dishSalesList = (await DishStatistics.getList(true, {
        dateFilter
      }))
      this.loading = false
    }
  }
}
</script>

<style scoped>

</style>
